export default __webpack_public_path__ + "static/media/moto.32ffe929.webp";